import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import currencySym from 'currency-symbol-map';
import CustomOfferBookingDetailsPage from './custom-offer-booking-details-page';
import CustomOfferAddOnsPage from './custom-offer-add-ons-page';
import CustomOfferReviewPage from './custom-offer-review-page';
import Breadcrumb from '../elements-breadcrum/breadcrumb';
import SeeCurrentDetails from './see-current-details';
import ModalManager from '../elements-modal/modal-manager-v2';
import CurrentDetailsContainer from '../app-main/containers/CurrentDetailsContainer';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { BookingSummary } from '../elements-summaries/booking-summary/BookingSummary';

class CustomOfferMain extends Component {
  componentDidMount() {
    const { booking, contract, location } = this.props;
    const path = _.get(location, 'pathname', null);
    const lastParam = path ? path.substr(path.lastIndexOf('/') + 1) : null;
    const contractData = _.get(contract, 'data.contracts', []);

    analyticsIntegrations.customOfferFormViewed(
      booking.booking,
      contractData,
      'edit-offer' === lastParam,
      'host-update-booking' === lastParam
    );
  }

  render() {
    const {
      booking = {},
      inventory = {},
      profile = {},
      payloadData = {},
      contract = {},
      currentStep,
      maxStepReached,
      add_ons,
      isEditOffer = false,
      iosWebView = false,
      toggleModal = null,
      whichModal = '',
      feeProfiles,
      handleBreadcrumbClick,
      intl
    } = this.props;

    const activityDetailBooking = { ...booking.booking };
    const ssoId = profile.SSOid;
    const contracts = _.get(contract, 'data.contracts', []);

    const payloadBooking = _.find(payloadData.items || {}, { type: 'BOOKING' });
    const payloadAttendees = _.get(
      payloadBooking,
      'info.number_of_guests',
      null
    );
    const payloadSchedule = _.get(payloadBooking, 'info.schedule', null);
    const spaceRental = contract.quote
      ? _.find(contract.quote.children, { type: 'SPACE_RENTAL' })
      : null;
    const updatedTotal = spaceRental
      ? parseFloat(
          _.get(spaceRental, 'amount.000000000000000000000000', 0)
        ).toFixed(2)
      : (0).toFixed(2);

    const currency = _.get(booking, 'booking.listing.prices[0].currency');
    const currencySymbol = currencySym(currency);

    const fetchedFeeProfiles = _.get(feeProfiles, 'hasFetched', false);

    if (!_.isEmpty(activityDetailBooking)) {
      activityDetailBooking.payment = {};
      activityDetailBooking.list_price = {};
      activityDetailBooking.payout = {};
      activityDetailBooking.view_as = 'HOST';
      activityDetailBooking.customOfferStep = currentStep;
      activityDetailBooking.attendees = payloadAttendees;
      activityDetailBooking.spaceRental = updatedTotal;
      activityDetailBooking.schedule = payloadSchedule;
      _.set(
        activityDetailBooking,
        'guest.sso_id',
        _.get(booking, 'guest.ssoid')
      );
      delete activityDetailBooking.host;
    }

    const pageDetails = {
      1: {
        header: this.props.intl.formatMessage({
          id: 'inbox.custom_offer_main.booking',
          defaultMessage: 'Booking details'
        }),
        component: (
          <CustomOfferBookingDetailsPage
            {...this.props}
            booking={booking.booking}
            contractData={contract.quote}
            currency={currency}
          />
        )
      },
      2: {
        header: this.props.intl.formatMessage({
          id: 'inbox.custom_offer_main.select_add_ons',
          defaultMessage: 'Select add-ons'
        }),
        component: (
          <CustomOfferAddOnsPage
            {...this.props}
            booking={booking.booking}
            inventory={inventory.data}
            addOns={add_ons}
            activityDetailBooking={activityDetailBooking}
            currency={currency}
            currencySymbol={currencySymbol}
            contracts={contracts}
          />
        )
      },
      3: {
        header: this.props.intl.formatMessage({
          id: 'inbox.custom_offer_main.review_submit',
          defaultMessage: 'Review and send for guest approval'
        }),
        component: (
          <CustomOfferReviewPage
            {...this.props}
            booking={booking.booking}
            contract={contract}
            ssoId={ssoId}
          />
        )
      }
    };
    const headerDisplay = pageDetails[currentStep].header;
    const componentDisplay = pageDetails[currentStep].component;
    const showCurrentDetails = isEditOffer && 3 === currentStep;

    return (
      <SharedIntlProviderHOC>
        <div className='CustomOfferMain ps-row'>
          {iosWebView && 'CurrentDetailsContainerModal' === whichModal && (
            <ModalManager whichModal={whichModal} toggleModal={toggleModal}>
              <div id='CurrentDetailsContainerModal'>
                <CurrentDetailsContainer {...this.props} booking={booking} />
              </div>
            </ModalManager>
          )}
          <div className="col-xs-12">
            <Breadcrumb
              currentStep={currentStep}
              steps={[
                {
                  step: 1,
                  disabled: 1 > maxStepReached,
                  text: this.props.intl.formatMessage({
                    id: 'inbox.custom_offer_main.booking_details',
                    defaultMessage: 'Booking details'
                  })
                },
                {
                  step: 2,
                  disabled: 2 > maxStepReached,
                  text: this.props.intl.formatMessage({
                    id: 'inbox.custom_offer_main.addons',
                    defaultMessage: 'Add-ons'
                  })
                },
                {
                  step: 3,
                  disabled: 3 > maxStepReached,
                  text: this.props.intl.formatMessage({
                    id: 'inbox.custom_offer_main.review',
                    defaultMessage: 'Review'
                  })
                }
              ]}
              onClick={handleBreadcrumbClick}
            />
          </div>
          <div className="col-xs-12 header">
            <h4 className=''>{headerDisplay}</h4>
          </div>
          <div
            className='col-lg-8 flex margin-xl-bottom'
            data-testing-id='custom-offer-step-container'
          >
            {!_.isEmpty(booking.booking) && componentDisplay}
          </div>
          <div className='col-lg-4 activity-details'>
            {!_.isEmpty(activityDetailBooking) && (
              <div>
                <BookingSummary
                  booking={activityDetailBooking}
                  profile={profile}
                  intl={intl}
                  iosWebViewConfig={{
                    isWebView: iosWebView
                  }}
                />
                {showCurrentDetails && (
                  <SeeCurrentDetails
                    className='margin-md-top'
                    iosWebView={iosWebView}
                    toggleModal={toggleModal}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </SharedIntlProviderHOC>
    );
  }
}

CustomOfferMain.propTypes = {
  booking: PropTypes.object,
  inventory: PropTypes.object,
  profile: PropTypes.object,
  currentStep: PropTypes.number,
  maxStepReached: PropTypes.number,
  createItem: PropTypes.func,
  add_ons: PropTypes.object,
  addOnsForm: PropTypes.object,
  toggleModal: PropTypes.func,
  whichModal: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  payloadData: PropTypes.object,
  isEditOffer: PropTypes.bool,
  isHostUpdate: PropTypes.bool,
  navigateBack: PropTypes.func,
  contract: PropTypes.object,
  iosWebView: PropTypes.bool,
  intl: intlShape,
  feeProfiles: PropTypes.object,
  handleBreadcrumbClick: PropTypes.func
};

export default injectIntl(CustomOfferMain);
